export function isNotEmptyObject(obj) {
  if (obj) {
    return Object.keys(obj).length > 0
  }
  return null
}
